<div class="modal-header modal-pepsico-header">
  <h1 class="modal-title fs-5" id="exampleModalLabel">ARTICULO AGREGADO</h1>
</div>
<div class="modal-body text-center">
  <div class="order-tracking-unique">
    @if(article()) {
    <div class="col-sm-12">
      <h5>Se agregó 1 artículo a tu lista.</h5>
      <img [src]="article()!.detailCatalogs[0].pathImage" alt="" class="newlist-img">
      <div class="bbb_viewed_name" [innerHTML]="article()?.description"></div>
    </div>
    <div class="jf-center">
      <button type="button" class="btn btn-warning wishlist" (click)="viewWishList()">
        Ver lista de deseos
      </button>
      <button type="button" class="btn btn-warning wishlist" (click)="closeModal()">
        Seguir canjeando
      </button>
    </div>
    }
  </div>
</div>